import {v1_RestrictedNichesToOffer_select_column} from '../../generated/types';

const RestrictedNichesToOffers = {
    ...v1_RestrictedNichesToOffer_select_column,
    res: 'v1_RestrictedNichesToOffer',
    comp: {},
    rel: {},
};

export default RestrictedNichesToOffers;
